module.exports = __webpack_public_path__ + "static/img/QuarterAcre.5ee016df.png";